import { createElement } from '@max/max';
// import { useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import './index.scss';
import { MTNewDigitalDisplayStyle } from "@/utils/common";
/**
 * 优惠券组件 - 支持展示多张优惠券
 */
export function RewardCoupon({ couponInfos, style, onClick }) {
    if (!couponInfos || couponInfos.length === 0) {
        return null;
    }
    return <View className="reward-coupon-container" style={style}>
      {couponInfos.map(couponInfo => {
        const { applyId, money, useRule, name, desc, url } = couponInfo;
        return <View key={applyId} className="reward-coupon-bg" style={{
            marginBottom: '24rpx'
        }}>
            
            <View className="reward-coupon-price-section">
              <View className="reward-coupon-price-box">
                <Text className="reward-coupon-currency" numberOfLines={1} style={MTNewDigitalDisplayStyle}>
                  ¥
                </Text>
                <Text className="reward-coupon-amount" style={MTNewDigitalDisplayStyle}>
                  {money}
                </Text>
              </View>
              <Text className="reward-coupon-threshold" numberOfLines={1}>
                {useRule}
              </Text>
            </View>

            
            <View className="reward-coupon-info-section">
              <Text className="reward-coupon-title" numberOfLines={1}>
                {name}
              </Text>
              <Text className="reward-coupon-subtitle" numberOfLines={1}>
                {desc}
              </Text>
            </View>

            
            <View className="reward-coupon-button-section">
              <Button className="reward-coupon-button" onPress={() => onClick === null || onClick === void 0 ? void 0 : onClick(url, applyId)}>
                <Text className="reward-coupon-button-text">去使用</Text>
              </Button>
            </View>
          </View>;
    })}
    </View>;
}
